import { render, staticRenderFns } from "./CouponRulesForm.vue?vue&type=template&id=41aedbc6"
import script from "./CouponRulesForm.vue?vue&type=script&lang=js"
export * from "./CouponRulesForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports